import {
  Datagrid,
  NumberField,
  TopToolbar,
  DateTimeInput,
  Filter,
  TextField,
  ArrayField,
} from "react-admin";
import { CustomList } from "../../shared/components/index.js";

const TotalFilter = (props) => (
  <Filter {...props}>
    <DateTimeInput source="start_date" alwaysOn />
    <DateTimeInput source="end_date" alwaysOn />
  </Filter>
);

const TotalList = (props) => {
  return (
    <CustomList
      rowClick={false}
      actions={<TopToolbar />}
      filters={<TotalFilter {...props} />}
    >
      <Datagrid
        bulkActionButtons={false}
        sx={{
          "& .RaDatagrid-headerCell": {
            textAlign: "center",
          },
          "& .RaDatagrid-rowCell": {
            textAlign: "center",
          },
        }}
      >
        <ArrayField
          source="total_sold_fuels"
          sortable={false}
          label="resources.Total.fields.total_sold_fuels.name"
        >
          <Datagrid
            bulkActionButtons={false}
            // sx={{
            //   "& .RaDatagrid-tbody": {
            //     backgroundColor: "#fafafb",
            //   },
            //   "& .RaDatagrid-rowCell": {
            //     backgroundColor: "#fafafb",
            //   },
            // }}
          >
            <TextField source="palyvo" />
            <NumberField source="money" />
            <NumberField source="litry" />
          </Datagrid>
        </ArrayField>
        <NumberField sortable={false} source="total_topup" />
        <NumberField sortable={false} source="total_left_balance" />
      </Datagrid>
    </CustomList>
  );
};

export default TotalList;
